<div class="card" >
    <app-header titulo="Cadastro de TMA" descricao="Cadastro da TMA referente aos contratos"></app-header>
  
    <div class="formgrid grid p-fluid">
          <div class="field col-3">
            <label for="empresaErp">Empresa ERP: </label>
            <p-dropdown
               appendTo="body"
               [options]="empresas"
               [filter]="true"
               optionValue="empresaErp"
               optionLabel="empresaErp"
               [(ngModel)]="taxa.deEmpresa"
               dataKey="id" inputId="id"
               placeholder="Código Empresa ERP"
                emptyMessage="Nenhuma código"
                >
              </p-dropdown>
          </div>
          <div class="field col-3">
            <label for="datainicial">Data Inicial: </label>
            <p-inputMask
              type="text"
              id="datainicial"
              
              
              mask="99/99/9999"
              
              [(ngModel)]="taxa.dataInicial"
              
            />
          </div>
          <div class="field col-3">
            <label for="datafinal">Data Final: </label>
            <p-inputMask
              type="text"
              id="datafinal"
              
              mask="99/99/9999"
              
              [(ngModel)]="taxa.dataFinal"
              
            />
          </div>
          <div class="field col-3">
            <label for="taxa">Taxa: </label>
            <p-inputNumber
              type="text"
              id="taxa"
              mode="decimal"
              [minFractionDigits]="0" 
              [maxFractionDigits]="5" 
              [(ngModel)]="taxa.taxa"
              
            />
          </div>
          <div class="field col-2 pt-4">
            <button
              pButton
              icon="pi pi-save"
              class="p-button-success"
              [label]="taxa.id ? 'Atualizar' : 'Salvar'"
              (click)="salvar()"
            ></button>
          </div>
          <div class="field col-2 pt-4">
            <button
             pButton label="Cancelar"
             icon="pi pi-times"
             class="p-button-text"
             (click)="fecharDialog()"></button>
          </div>
    </div>
  </div>
  